module.exports = __webpack_public_path__ + "img/cross-mark.54f30bd6.png";